/**
 * Created by lobin on 2019/1/21.
 */
import { request } from "../../plugins/axios";
const state = {};
const getters = {};

const actions = {
  /**
   * 修改用户基本信息
   * @param data
   * @return {Promise.<void>}
   */
  async modifyUserBaseInfo({}, data) {
    return request({
      url: "/portal/job-seekers/info?language=1",
      method: "put",
      data
    });
  },
  /**
   * 添加教育经历
   * @param data
   * @return {Promise.<void>}
   */
  async addEducation({}, data) {
    return request({
      url: "/portal/job-seekers/educational-backgrounds?language=1",
      method: "post",
      data
    });
  },
  // 删除教育经历
  async delEducation({}, id) {
    return request({
      url: `/portal/job-seekers/educational-backgrounds?language=1&id=${id}`,
      method: "delete"
    });
  },
   // 编辑教育经历
  async editEducation({}, data) {
    return request({
      url: `/portal/job-seekers/educational-backgrounds?language=1&id=${data.id}`,
      method: "put",
      data
    });
  },
  //教育经历列表数据
  async getEducation() {
    return request({
      url: "/portal/job-seekers/educational-backgrounds?language=1"
    });
  },


  /**
   * 添加求职期望
   * @param data
   * @return {Promise.<void>}
   */
  async addJobExpect({}, data) {
    return request({
      url: "/portal/job-seekers/desire",
      method: "post",
      data
    });
  },
  // 删除求职期望
  async delJobExpect({}, id) {
    return request({
      url: `/portal/job-seekers/desire/${id}`,
      method: "delete"
    });
  },
   // 编辑求职期望
  async editJobExpect({}, data) {
    return request({
      url: `/portal/job-seekers/desire/${data.id}`,
      method: "put",
      data
    });
  },
  //求职期望列表数据
  async getJobExpect() {
    return request({
      url: "/portal/job-seekers/desire"
    });
  },

  async getWorkExperience() {
    return request({
      url: "/portal/job-seekers/work-experiences?language=1&debug=true"
    });
  },
  async getProjectExperience() {
    return request({
      url: "/portal/job-seekers/project-experiences?language=1&debug=true"
    });
  },
  async addWorkExperience({}, data) {
    return request({
      url: "/portal/job-seekers/work-experiences?language=1&debug=true",
      method: "post",
      data
    });
  },
  async delWorkExperience({}, id) {
    return request({
      url: `/portal/job-seekers/work-experiences?language=1&id=${id}`,
      method: "delete"
    });
  },
  async editWorkExperience({}, data) {
    return request({
      url: `/portal/job-seekers/work-experiences?language=1&debug=true&id=${data.id}`,
      method: "put",
      data
    });
  },
  async addProjectExperience({}, data) {
    return request({
      url: "/portal/job-seekers/project-experiences?language=1&debug=true",
      method: "post",
      data
    });
  },
  async delProjectExperience({}, id) {
    return request({
      url: `/portal/job-seekers/project-experiences?language=1&id=${id}`,
      method: "delete"
    });
  },
  async editProjectExperience({}, data) {
    return request({
      url: `/portal/job-seekers/project-experiences?language=1&debug=true&id=${data.id}`,
      method: "put",
      data
    });
  },
  async downloadAtt({}, formate) {
    return request({
      url: `/portal/job-seekers/download?language=1&format=${formate}`,
      responseType: "blob"
    });
  },
  async deletAttResume({}, id) {
    return request({
      url: `/portal/resume/online/${id}`,
      method: "delete"
    });
  },
  async getMyLabels() {
    return request({ url: "/portal/label/1" });
  },
  addLabels({}, { userLabel, userDefindLabel }) {
    return request({
      url: `/portal/job-seekers/addLabel?userLabel=${userLabel}&userDefindLabel=${userDefindLabel}&language=1`,
      method: "put"
    });
  },
  checkEmailAction({}, email) {
    return request({
      url: `/portal/users/verify/email?mail=${email}`
    });
  },
  emailVerify({}, { email, captcha }) {
    return request({
      url: `/portal/users/verify/email?mail=${email}&captcha=${captcha}`,
      method: "put"
    });
  }
};
const mutations = {
  setState(state, { key, data }) {
    state[key] = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
